'use client'

import { useCallback, useState } from 'react'
import { useSessionStorage } from 'usehooks-ts'

import { useExperimentsContext } from '../experiments/components/ExperimentsContext'
import { useGetExperiment } from '../experiments/hooks/useGetExperiment'
import { EXPERIMENT_NAME_CTA_BUTTON_ON_ALL_CSW } from '../experiments/model/EXPERIMENT_NAME'

export const useCrossSellIntersection = (): {
  handleIntersection: () => void
  intersected: boolean
} => {
  const experimentCtaButtonOnAllCsw = useGetExperiment(
    EXPERIMENT_NAME_CTA_BUTTON_ON_ALL_CSW,
  )
  const { addExperimentKeysForActivation } = useExperimentsContext()
  const [
    experimentCtaButtonOnAllCswActive,
    setExperimentCtaButtonOnAllCswActive,
  ] = useSessionStorage(EXPERIMENT_NAME_CTA_BUTTON_ON_ALL_CSW, 0, {
    initializeWithValue: false,
  })
  const [intersected, setIntersected] = useState(false)

  const handleIntersection = useCallback(() => {
    if (
      experimentCtaButtonOnAllCsw.isEnabled &&
      !experimentCtaButtonOnAllCswActive
    ) {
      addExperimentKeysForActivation(experimentCtaButtonOnAllCsw.name)
      setExperimentCtaButtonOnAllCswActive(1)
    }
    setIntersected(true)
  }, [
    addExperimentKeysForActivation,
    experimentCtaButtonOnAllCsw,
    experimentCtaButtonOnAllCswActive,
    setExperimentCtaButtonOnAllCswActive,
  ])

  return { handleIntersection, intersected }
}
